import mixins from 'vue-typed-mixins'
import DraftElement from '@/calendesk/sections/section/mixins/DraftElement'
import GetCompanyDataRequestData from '@/calendesk/models/DTO/Request/GetCompanyDataRequestData'
import CompanyData from '@/calendesk/models/DTO/Response/CompanyData'
import { errorNotification } from '@/calendesk/prototypes/notifications'
import { mapActions } from 'vuex'

export default mixins(DraftElement).extend({
  data () {
    return {
      companyVatIsoPrefix: null as string | null,
      companyTaxNumber: null as string | null,
      companyName: null as string | null,
      companyStreet: null as string | null,
      companyPostalCode: null as string | null,
      companyCity: null as string | null,
      companyCountryIsoCode: null as string | null,
      email: null as string | null,
      name: null as string | null,
      surname: null as string | null,
      phone: null as string | null,
      showBillingData: false,
      isLoadingCompanyData: false,
      billingDataType: 0
    }
  },
  computed: {
    companyDataFilled (): boolean {
      return (!!this.companyTaxNumber ||
        !!this.companyName ||
        !!this.companyStreet ||
        !!this.companyPostalCode ||
        !!this.companyCity)
    },
    billingDataTypeCompany (): boolean {
      return this.billingDataType === 0
    },
    billingDataTypePerson (): boolean {
      return this.billingDataType === 1
    },
    requireBillingData (): boolean {
      // Abstract, implement yourself.
      return false
    }
  },
  watch: {
    isUserLogged () {
      this.reloadUserData()
      this.reloadCompanyData()
    }
  },
  created () {
    this.reloadUserData()
    this.reloadCompanyData()
  },
  methods: {
    ...mapActions({
      getCompanyData: 'user/getCompanyData'
    }),
    reloadUserData () {
      if (this.isUserLogged) {
        this.name = this.user.name
        this.surname = this.user.surname
        this.email = this.user.email
        this.phone = this.user.defaultPhone ? this.user.defaultPhone.e164 : null
      }
    },
    reloadCompanyData () {
      if (this.isUserLogged) {
        if (this.user.hasDefaultAddress()) {
          this.showBillingData = true
          this.companyName = this.user.defaultAddress.name
          this.companyVatIsoPrefix = this.user.defaultAddress.vatIsoPrefix
          this.companyTaxNumber = this.user.defaultAddress.taxNumber
          this.companyStreet = this.user.defaultAddress.street
          this.companyCity = this.user.defaultAddress.city
          this.companyPostalCode = this.user.defaultAddress.postalCode
          this.companyCountryIsoCode = this.user.defaultAddress.countryIsoCode
        } else {
          this.companyVatIsoPrefix = (this.appConfiguration.companyCountryIsoCode || this.appConfiguration.language).toUpperCase()
          this.companyCountryIsoCode = (this.appConfiguration.companyCountryIsoCode || this.appConfiguration.language).toLowerCase()
        }
      } else {
        this.companyVatIsoPrefix = (this.appConfiguration.companyCountryIsoCode || this.appConfiguration.language).toUpperCase()
        this.companyCountryIsoCode = (this.appConfiguration.companyCountryIsoCode || this.appConfiguration.language).toLowerCase()
      }

      if (!this.companyTaxNumber && !this.companyVatIsoPrefix && !this.companyName) {
        this.billingDataType = 1
      }
    },
    getCompanyDataHandler () {
      this.isLoadingCompanyData = true

      let prefix = this.companyVatIsoPrefix

      if (!prefix) {
        prefix = this.appConfiguration.language
      }

      this.getCompanyData(new GetCompanyDataRequestData(prefix, this.companyTaxNumber))
        .then((data: CompanyData) => {
          this.companyName = data.name
          this.companyStreet = data.street
          this.companyCity = data.city
          this.companyPostalCode = data.postalCode
          this.companyCountryIsoCode = data.countryIsoCode
          this.companyTaxNumber = data.taxNumber
        }).catch(() => {
          errorNotification('get_company_data_failed', null, false)
        }).finally(() => {
          this.isLoadingCompanyData = false
        })
    }
  }
})
